import React from 'react';
import { PropTypes } from 'prop-types';

import { LoadingWrapper } from './styles';

const LoadingComponent = ({ show, text }) => !!show && <LoadingWrapper data-testid="loading-text">{text || 'Loading'}</LoadingWrapper>;

LoadingComponent.propTypes = {
  text: PropTypes.string,
  show: PropTypes.bool,
};

export default LoadingComponent;
